import React from 'react';
import { Button } from 'react-bootstrap';
import PropTypes from 'prop-types';

const ServiceDesc = ({ options, toggleDescription }) => (
  <div className="services-import__list-service-footer">
    <Button bsSize="xsmall" onClick={toggleDescription}>
      Description
    </Button>
    <div className="services-import__list-service-footer-icons">
      {options.dripfeed && <span className="icon fas fa-tint" />}
      {options.refill && <span className="icon far fa-sync-alt" />}
      {options.cancel && <span className="icon far fa-ban" />}
    </div>
  </div>
);

ServiceDesc.propTypes = {
  options: PropTypes.object,
  toggleDescription: PropTypes.func,
};

export default ServiceDesc;
